import React from "react";
import styles from "../styles/Navbar.module.scss"
import { slide as Menu } from 'react-burger-menu'
import { useMediaQuery } from 'react-responsive'
import '../styles/global.scss'


export const Navbar = () => {
    const menuItems = [{
        title: "projetos",
        src: "#projects"
    },
    {
        title: "habilidades",
        src: "#skills"
    },
    {
        title: "sobre",
        src: "#about"
    }
    ]

    const isMobile = useMediaQuery({
        query: '(max-width: 767px)'
      })

    const [isMenuOpen, setIsMenuOpen] = React.useState(false)

    const handleMenuChange = function(state) {
        setIsMenuOpen(state.isOpen)
      };


    return (
        <nav className={styles.navbar}>
            {isMobile ? 
            (
                <Menu isOpen={isMenuOpen} onStateChange={(state) => handleMenuChange(state)}>
                    {menuItems.map((item) => <a className={styles.link} href={item.src} onClick={() => setIsMenuOpen(false)}>{item.title}</a>)}
                </Menu>
            ) :
            (
            <ul className={styles.list}>
                {menuItems.map((item) =>
                    <a className={styles.link} href={item.src}><li className={styles.listItem}>{item.title}</li></a>
                )}
            </ul>

            )}
        </nav>
    )
}